import { Checkbox } from '@/components';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import React, { Fragment } from 'react';
import { SectionGroup } from '../../types';

interface StateProps {
  sectionGroups: SectionGroup[];
}

interface DispatchProps {
  onSelectAllSubGroups: (categoryId: string, subCategoryId: string, checked: boolean) => void;
  onCheckProduct: (categoryId: string, subCategoryId: string, productId: string) => void;
  onCheckCombo: (categoryId: string, subCategoryId: string, comboId: string) => void;
}

type Props = StateProps & DispatchProps;

export const SectorConfigContent: React.FC<Props> = ({
  sectionGroups,
  onSelectAllSubGroups,
  onCheckProduct,
  onCheckCombo,
}) => (
  <Fragment>
    <h6 className="mb-4">Selecione os produtos e combos que este setor poderá vender</h6>
    {sectionGroups &&
      sectionGroups.length > 0 &&
      sectionGroups.map((sectionGroup, indexGroup) => (
        <Fragment key={`category-group-${indexGroup}-${sectionGroup.categoryGroupId}`}>
          {sectionGroup.subGroups &&
            sectionGroup.subGroups.length > 0 &&
            sectionGroup.subGroups.map((subGroup, indexSub) => (
              <SuperCollapse
                key={`category-sub-group-${indexSub}-${subGroup.categorySubGroupId}`}
                title={`${sectionGroup.categoryGroupName} // ${subGroup.categorySubGroupName}`}
                leftIcon={
                  <Checkbox
                    name={`${sectionGroup.categoryGroupName} + ${subGroup.categorySubGroupName}`}
                    checked={subGroup.checked}
                    onChange={() => {
                      onSelectAllSubGroups(
                        sectionGroup.categoryGroupId,
                        subGroup.categorySubGroupId,
                        !subGroup.checked,
                      );
                    }}
                  />
                }
                content={
                  <>
                    {!!subGroup.products.length && (
                      <div className="mb-3">
                        <div className="mb-4">
                          <span className="text-dark">Produtos</span>
                        </div>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            alignItems: 'center',
                          }}
                        >
                          {!!subGroup.products.length &&
                            subGroup.products.map(data => (
                              <div
                                className="dataConfig.form-check"
                                key={`category-subcategory-product-${data.id}`}
                              >
                                <Checkbox
                                  label={data.name}
                                  name={data.name}
                                  checked={data.checked}
                                  onChange={() =>
                                    onCheckProduct(
                                      sectionGroup.categoryGroupId,
                                      subGroup.categorySubGroupId,
                                      data.id,
                                    )
                                  }
                                />
                              </div>
                            ))}
                        </div>
                      </div>
                    )}
                    {!!subGroup.combos.length && (
                      <div>
                        <div className="mb-4">
                          <span className="text-dark">Combos</span>
                        </div>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            alignItems: 'center',
                          }}
                        >
                          {subGroup.combos.map(data => (
                            <>
                              <div
                                className="dataConfig.form-check"
                                key={`category-subcategory-combo-${data.id}`}
                              >
                                <Checkbox
                                  label={data.name}
                                  name={data.name}
                                  checked={data.checked}
                                  onChange={() =>
                                    onCheckCombo(
                                      sectionGroup.categoryGroupId,
                                      subGroup.categorySubGroupId,
                                      data.id,
                                    )
                                  }
                                />
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                }
              />
            ))}
        </Fragment>
      ))}
  </Fragment>
);
